import { render, staticRenderFns } from "./bonusChangeInfo.vue?vue&type=template&id=2afcf522&scoped=true&"
import script from "./bonusChangeInfo.vue?vue&type=script&lang=js&"
export * from "./bonusChangeInfo.vue?vue&type=script&lang=js&"
import style0 from "./bonusChangeInfo.vue?vue&type=style&index=0&id=2afcf522&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afcf522",
  null
  
)

export default component.exports